import * as React from "react";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MainLayout from "@/components/template/dashboard-layout";
import Quests from "@/components/organisms/quests";
import { QuestType } from "@/types/quests";
import NotFoundPage from "./404";

export default function QuestsPage() {
  const { type } = useParams<{ type?: string }>();
  const navigate = useNavigate();

  // Default to "daily" if no type is specified
  const currentType: QuestType = (type as QuestType) || "unique";

  // Validate the quest type
  const validTypes: QuestType[] = ["daily", "weekly", "unique"];
  if (type && !validTypes.includes(type as QuestType)) {
    return <NotFoundPage />;
  }

  const handleTabChange = (tab: QuestType) => {
    const newPath = tab === "unique" ? "/quests" : `/quests/${tab}`;
    navigate(newPath);
  };

  return (
    <MainLayout>
      <Quests selectedTab={currentType} onTabChange={handleTabChange} />
    </MainLayout>
  );
}
